<template>
  <button
    type="button"
    class="action-btn"
    :disabled="loading"
  >
    <span v-show="!loading">{{ text }}</span>
    <ClipLoader :loading="loading" :color="'#fff'" :size="'20px'"></ClipLoader>
  </button>
</template>

<script>
  import ClipLoader from 'vue-spinner/src/ClipLoader';
  
  export default {
    name: "FPButtonLoader",
    components: {
      ClipLoader
    },
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      text: {
        type: String,
        required: true
      }
    },
  }
</script>